export default __webpack_public_path__ + "assets/732ea7df11bdb868bd1200b8422156fb.png";